module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('div', {
    staticClass: "back"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/back@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Forgot Password")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email input-view",
    attrs: {
      "type": "text",
      "placeholder": "Enter your Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.forgotClick.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn_forgot",
    on: {
      "click": _vm.forgotClick
    }
  }, [_vm._v("Next")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abb11330"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forgot.vue
// module id = 793
// module chunks = 1